import SolicitationsRequests from '../../server/solicitations';
import { addLoading, removeLoading } from './loading';

export const setSolicitations = res => ({
  type: 'GET_SOLICITATIONS',
  solicitations: res,
});

export const getSolicitations = searchType => async (dispatch) => {
  dispatch(addLoading());
  try {
    const solicitations = await SolicitationsRequests.getSolicitations(searchType);
    dispatch(setSolicitations(solicitations));
  } finally {
    dispatch(removeLoading());
  }
};

export const solicitationUserClient = solicitationId => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SolicitationsRequests.solicitationUserClient(solicitationId);
  } finally {
    dispatch(removeLoading());
  }
};

export const solicitationApproveUser = (solicitationId, data) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const response = await SolicitationsRequests.solicitationApproveUse(solicitationId, data);
    return response;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvSolicitationsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await SolicitationsRequests.getCsvSolicitationsReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const updateStatusSolicitations = (solicitationId, solicitationStatus) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await SolicitationsRequests.updateStatusSolicitations(solicitationId, solicitationStatus);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadImage = imageName => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await SolicitationsRequests.downloadImage(imageName);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadImages = async (
  file,
  name,
  imageToChange,
  clientId,
  userId,
  stateToUpdate,
  solicitation,
  idSolicitation,
) => SolicitationsRequests.uploadImages(
  file,
  name,
  imageToChange,
  clientId,
  userId,
  stateToUpdate,
  solicitation,
  idSolicitation,
);
